module.exports = __webpack_public_path__ + "static/img/splogo.f631398.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagesHz/splogo.gif
// module id = NJyo
// module chunks = 27